import * as React from 'react';
import { ChangeEvent } from 'react';
import { Grid } from '@mui/material';
import { Field, useForm } from 'react-final-form';
import { TravellerFields } from '../../types';
import Input from '../../../BaseComponents/Input';
import { useTheme } from '../../../theme';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { MOBILE_MIN_WIDTH } from '../../../utils';
import { InputVariant } from '../../../BaseComponents/Input/types';
import PhoneInput from '../../../PhoneInput';

const ContactsSection = () => {
	const { ContactsSection: css } = useTheme('TravellerForm');

	const { t: tDocumentCardForm } = useTranslation('DocumentCardForm');
	const { t: tTraveller } = useTranslation('Traveller');

	const isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });

	const variant: InputVariant = isMobile ? 'underline' : 'labelIn';

	const form = useForm();

	return (
		<div className={css.contactsSection}>
			<Grid container spacing={2} sx={{ flex: 1, minWidth: 0 }}>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Field
						name={TravellerFields.Email}
						render={({ input, meta }) => (
							<Input
								{...input}
								className={css.input}
								variant={variant}
								value={input.value}
								label={`${tTraveller('email')}`}
								error={meta.error && meta.touched}
								helperText={meta.touched && tDocumentCardForm(meta.error)}
								onChange={(event: ChangeEvent<HTMLInputElement>) => {
									input.onChange(event);
									form.mutators.fixEmptyFieldMutator({ fieldName: TravellerFields.Email });
								}}
							/>
						)}
					/>
				</Grid>

				<Grid size={{ xs: 12, sm: 6 }}>
					<Field
						name={TravellerFields.Phone}
						type="tel"
						render={({ input, meta }) => (
							<PhoneInput
								value={input.value}
								textFieldsProps={{
									label: `${tTraveller('phone')}`,
									error: meta.error && meta.touched,
									helperText: meta.touched && tDocumentCardForm(meta.error),
									onBlur: (e: React.FocusEvent<HTMLInputElement>) => {
										input.onBlur(e);
									},
									onChange: value => {
										input.onChange({
											...new Event('change'),
											target: {
												...input,
												value: value
											}
										});
										form.mutators.fixEmptyFieldMutator({ fieldName: TravellerFields.Phone });
									}
								}}
								renderInput={props => {
									return (
										<Input
											{...props.TextFieldProps}
											variant={variant}
											value={props.value}
											className={css.input}
										/>
									);
								}}
							/>
						)}
					/>
				</Grid>
			</Grid>
		</div>
	);
};

export default ContactsSection;
